/**
 * Логика водоснабжения: точка по id, проверки вида и какие среды она принимает.
 *
 * Проверки принимают любой элемент каталога (так их вызывает общий код холста и
 * панелей, у которого в руках `CatalogItem`) и смотрят в разделе водоснабжения по id.
 */
import type { CatalogItem } from "../../types";
import { WATER_MEDIUM_COLOR, waterSection } from "./catalog";
import { WaterMedium, WaterPointKind, type WaterCatalogItem } from "./types";

export const waterItemById = (id: string): WaterCatalogItem | null =>
	waterSection.items.find((item) => item.id === id) ?? null;

/** Точка ли это водоснабжения — по членству в разделе. Трубы ведут только между такими. */
export const isWaterPoint = (item: CatalogItem | null): boolean =>
	item !== null && waterItemById(item.id) !== null;

/** Вид точки; null — это не водоснабжение или тип удалён из каталога. */
export const waterPointKindOf = (item: CatalogItem | null): WaterPointKind | null =>
	item ? (waterItemById(item.id)?.kind ?? null) : null;

export const isRiser = (item: CatalogItem | null): boolean =>
	waterPointKindOf(item) === WaterPointKind.Riser;
export const isManifold = (item: CatalogItem | null): boolean =>
	waterPointKindOf(item) === WaterPointKind.Manifold;
export const isOutlet = (item: CatalogItem | null): boolean =>
	waterPointKindOf(item) === WaterPointKind.Outlet;

/** Принимает ли точка среду: к стояку ХВС горячую трубу не подвести. */
export const acceptsMedium = (item: CatalogItem | null, medium: WaterMedium): boolean =>
	item !== null && (waterItemById(item.id)?.media.includes(medium) ?? false);

/** Цвет трубы и трассы по среде. */
export const waterMediumColor = (medium: WaterMedium): string => WATER_MEDIUM_COLOR[medium];

/** Подпись среды для интерфейса. */
export const waterMediumLabel = (medium: WaterMedium): string =>
	medium === WaterMedium.Hot ? "ГВС" : "ХВС";
